module.exports = __webpack_public_path__ + "static/media/assign.971cc647.svg";